import Rebase from 're-base'
import firebase from 'firebase/app'
import 'firebase/database'

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyD3TeHZ0wSyIh0WKCKn-M_ed7hQ_z7n7bw',
  authDomain: 'boite-a-recettes-715d6.firebaseapp.com',
  databaseURL: 'https://boite-a-recettes-715d6.firebaseio.com'
})

const base = Rebase.createClass(firebaseApp.database())

// This is a named export
export { firebaseApp }

// this is a default export
export default base
